<div [ngClass]="{ 'obg-menu-item-list-vertical': isOrientationVertical }">
	<span class="menu-item-list-title" *ngIf="titleText">{{ titleText }}</span>

	<a
		*ngFor="let item of items; trackBy: trackByItem"
		attr.test-id="{{ item.key }}"
		attr.data-test-id="{{ item.key }}"
		[obgRouteLink]="{ route: item.route, url: item.link?.url, target: item.link?.target }"
		[target]="item.link?.target"
		[obgInteraction]="uiInteraction"
		>{{ item.title }}</a
	>
</div>
